import { getAnalyticsBrand } from './getAnalyticsBrand';
import { IAppState } from '../../redux';
import { getAnalyticsCategory } from './getAnalyticsCategory';
import { getAnalyticsVariant } from './getAnalyticsVariant';
import { IPlacingTerms } from '../../../browser/addform/types';
import { getSelected } from '../../selectors/placingTermsApi';
import { IAnalyticsProduct } from '../../types/analytics';

// Эта утилита полезна только для использования в angular
export const getAnalyticsProduct = (state: IAppState, placingTermsApi: IPlacingTerms): IAnalyticsProduct => {
  const {
    offer: {
      id,
      category,
      bargainTerms: { price },
    },
    user,
  } = state;

  const selected = getSelected(placingTermsApi);

  const variant = getAnalyticsVariant(selected);

  return {
    brand: getAnalyticsBrand(user),
    // тип сделки/тип объекта
    category: getAnalyticsCategory(category),
    // id объявления
    id,
    // стоимость объекта
    price,
    // VAS
    variant,
  };
};
